<template>
  <div class="customer-consultation">
    <HeroBanner
      :background-image="bannerImage"
      :title="title"
      :sub-title="subTitle"
    />

    <div class="consultation-content">
      <div class="section-header">
<!--        <h2 class="section-title">상담 예약</h2>-->
        <h2 class="section-title">{{title}}</h2>
      </div>

      <form class="consultation-form" @submit.prevent="submitConsultation">
        <div class="form-group">
          <label class="form-label">
            신청자 정보<span class="required">*</span>
          </label>
          <div class="radio-group">
            <div class="radio-item">
              <input
                type="radio"
                id="applicant-self"
                value="본인"
                v-model="formData.applicantType"
              />
              <label for="applicant-self">본인</label>
            </div>
            <div class="radio-item">
              <input
                type="radio"
                id="applicant-guardian"
                value="보호자"
                v-model="formData.applicantType"
              />
              <label for="applicant-guardian">보호자</label>
            </div>
            <div class="radio-item">
              <input
                type="radio"
                id="applicant-other"
                value="기타"
                v-model="formData.applicantType"
              />
              <label for="applicant-other">기타</label>
            </div>
          </div>
        </div>

        <!-- 방문 고객명 -->
        <div class="form-group">
          <label for="customer-name" class="form-label">
            방문 고객명<span class="required">*</span>
          </label>
          <input
            type="text"
            id="customer-name"
            v-model="formData.customerName"
            placeholder="성함을 입력해주세요"
            maxlength="20"
            class="form-input"
          />
        </div>

        <!-- 연락처 -->
        <div class="form-group">
          <label for="contact" class="form-label">
            연락처<span class="required">*</span>
          </label>
          <input
            type="tel"
            id="contact"
            v-model="formData.contact"
            placeholder="연락처를 입력해주세요"
            maxlength="11"
            class="form-input"
          />
        </div>

        <!-- 상담받을 매장 -->
        <div class="form-group store-group">
          <span class="form-label" id="store-field-label">
            상담받을 매장<span class="required">*</span>
          </span>
          <div class="store-field">
            <p class="store-field-name" :class="{ 'is-empty': !formData.store }">
              {{ formData.store ? formData.store.name : '선택해주세요' }}
            </p>
            <button
              type="button"
              id="store-select"
              class="store-field-btn"
              :aria-expanded="storePickerOpen ? 'true' : 'false'"
              aria-describedby="store-field-label"
              @click="storePickerOpen = !storePickerOpen"
            >
              {{ storePickerOpen ? '닫기' : formData.store ? '매장 변경' : '매장 선택' }}
            </button>
          </div>
        </div>
        <StorePicker v-model="formData.store" :open.sync="storePickerOpen" />

        <!-- 개인정보 수집 동의 -->
        <PrivacyConsent
          title="[개인정보 수집·이용 동의 안내]"
          v-model="formData.privacyConsent"
          :contents="privacyContents"
          checkbox-id="consultation-privacy-consent"
          label="[필수] 개인정보 수집·이용에 동의합니다."
        />
        <!-- 제출 버튼 -->
        <button type="submit" class="submit-button">
          {{btnTitle}}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import PrivacyConsent from "@/components/PrivacyConsent.vue";
import StorePicker from "@/components/SUPPORT/StorePicker.vue";
import bannerBg from '@/assets/images/heros/06-top-img.png';
import bannerBg2x from '@/assets/images/heros/06-top-img@2x.png';
import axios from "@/api/axios-auth";
import { mapState } from "vuex";
import {
  sanitizeCustomerName,
  sanitizeContact,
  validatePhoneNumber,
  getInitialFormData
} from "@/utils/consultationUtils";

export default {
  name: 'CustomerConsultation',
  components: {
    HeroBanner,
    PrivacyConsent,
    StorePicker
  },
  data() {
    return {
      // btnTitle : "무료 상담 신청하기",
      btnTitle : "간편 상담 신청하기",
      // title : "상담 예약",
      title : "간편 상담 신청",
      // subTitle : "간단한 정보만 남겨도 상담 신청이 가능합니다.<br>남겨주신 연락처로 전화드리겠습니다.",
      subTitle : "무료 청력검사 및 보청기 무료체험 등<br>보청기 관련 상담 도와드립니다.",
      bannerImage: [bannerBg, bannerBg2x],
      formData: getInitialFormData(),
      storePickerOpen: false,
      isSubmitting: false // 추가
    };
  },
  computed: {
    ...mapState({
      privacyContents: (state) => state.others?.privacy?.[0]?.contents || ''
    })
  },
  watch: {
    'formData.customerName'(value) {
      const result = sanitizeCustomerName(value);
      this.$nextTick(() => {
        this.formData.customerName = result;
      });
    },
    'formData.contact'(value) {
      const result = sanitizeContact(value);
      this.$nextTick(() => {
        this.formData.contact = result;
      });
    }
  },
  methods: {
    validateForm() {
      if (!this.formData.applicantType) {
        alert('신청자 정보를 선택해주세요.');
        return false;
      }
      if (!this.formData.customerName.trim()) {
        alert('방문 고객명을 입력해주세요.');
        return false;
      }
      if (!this.formData.contact.trim()) {
        alert('연락처를 입력해주세요.');
        return false;
      }
      if (!validatePhoneNumber(this.formData.contact)) {
        alert('올바른 연락처를 입력해주세요.');
        return false;
      }
      if (!this.formData.store) {
        alert('상담받을 매장을 선택해주세요.');
        return false;
      }
      if (!this.formData.privacyConsent) {
        alert('개인정보 수집에 동의해주세요.');
        return false;
      }
      return true;
    },
    async submitConsultation() {
      if (this.isSubmitting) return;
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true; // 요청 시작
      try {
        await axios.post('/service/simple_consultation_history', {
          name: this.formData.customerName,
          hphone: this.formData.contact,
          content: `${this.formData.applicantType} 상담 요청`,
          apply_type: this.formData.applicantType,
          // 매장코드, 매장명 추가
          str_code: this.formData.store.strCode,
          str_name: this.formData.store.name
        });

        let conversionSent = false;

        // Google Ads 전환 이벤트 (성공 시점에만)
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-16894553588/UR8ACNf7muobEPTb-fc-'
          });
          conversionSent = true;
          console.log('[gtag] conversion fired', window.dataLayer?.slice(-5));
        } else {
          // gtag가 아직 로드 안 됐거나 미설치인 경우
          console.warn('[gtag] not available - conversion event not sent');
        }
        alert('상담 신청이 완료되었습니다. 감사합니다.');

        this.formData = getInitialFormData();
      }
      catch (error) {
        console.error('상담 신청 오류:', error);
        console.error('에러 응답:', error.response?.data);
        alert('상담 신청 중 오류가 발생했습니다. 다시 시도해주세요.');
      } finally {
          this.isSubmitting = false; // 성공/실패 상관없이 해제
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";

.customer-consultation {
  .consultation-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 80px 38px 100px;

    .section-header {
      text-align: left;
      margin-bottom: 50px;
      padding-bottom: 20px;
      border-bottom: 2px solid #222;

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #222;
      }
    }

    .consultation-form {
      max-width: 800px;

      .form-group {
        max-height: 88px;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 1fr 275px;
        display: grid;
        margin-bottom: 24px;
        .form-label {
          display: block;
          font-family: font family/Font 1;
          font-weight: font weight/500;
          font-style: Medium;
          font-size: 20.78px;
          leading-trim: NONE;
          line-height: 41.55px;
          letter-spacing: -0.62px;
          vertical-align: middle;
          .required {
            color: $color-skyblue;
            margin-left: 4px;
          }
        }

        .radio-group {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          .radio-item {
            display: flex;
            align-items: center;
            justify-content: center;
            input[type="radio"] {
              display: none;
            }
            input[type="radio"]:checked{
              + label{
                color: $color-blue;
                background: #E7F2FFFF;
                //box-shadow: 0 0 0 2px $color-blue inset;
                //border: none;
                font-weight: 600;
                //accent-color: red;
              }
            }
            &:last-child label{
              border-right: 1px solid #222;
            }
            label {
              padding: 32px 0;
              border: 1px solid #222;
              border-right: none;
              //box-shadow: 0 0 0 1px #222 inset;
              max-width: 92px;
              width: 100%;
              font-family: font family/Font 1;
              font-weight: font weight/500;
              font-style: Medium;
              font-size: 22.16px;
              leading-trim: NONE;
              letter-spacing: -0.62px;
              text-align: center;
              vertical-align: middle;
              cursor: pointer;
              user-select: none;
            }
          }
        }
        .form-input,
        .form-select {
          padding: 16px 20px;
          font-size: 16px;
          border-bottom: 1px solid #ddd;
          font-weight: 350;
          font-size: 22.16px;
          leading-trim: NONE;
          line-height: 100%;
          vertical-align: middle;
          transition: border-color 0.3s;

          &:focus {
            outline: none;
            border-color: $color-blue;
          }

          &::placeholder {
            color: #999;
          }
        }

        .form-input::placeholder{
          color: #ccc;
        }
        // 다른 칸(연락처 등)과 같은 줄 배치: 라벨 왼쪽, 매장명+버튼 오른쪽
        &.store-group {
          max-height: none;
        }
        .store-field {
          display: flex;
          align-items: center;
          min-height: 70px;
          padding: 8px 0 8px 20px;
          border-bottom: 1px solid #ddd;
          @media (max-width: 768px) {
            min-height: 60px;
            padding: 8px 0 8px 12px;
          }
        }
        .store-field-name {
          flex: 1;
          min-width: 0;
          margin-right: 10px;
          font-weight: 350;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: -0.4px;
          word-break: keep-all;
          overflow-wrap: anywhere;
          // 세 줄로 넘어가지 않게 (매장명은 두 줄 안에 다 들어간다)
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          &.is-empty {
            color: #ccc;
          }
          @media (max-width: 768px) {
            margin-right: 8px;
            font-size: 15px;
            line-height: 21px;
            letter-spacing: -0.3px;
          }
        }
        .store-field-btn {
          flex-shrink: 0;
          min-width: 0;
          min-height: 0;
          height: 40px;
          padding: 0 14px;
          border: 1px solid $color-blue;
          background-color: $color-white;
          color: $color-blue;
          font-size: 16px;
          font-weight: 500;
          white-space: nowrap;
          transition: background-color 0.2s;
          &:hover {
            background-color: #e7f2ff;
          }
          @media (max-width: 768px) {
            height: 32px;
            padding: 0 10px;
            font-size: 13px;
          }
        }
      }
      .consent-notice {
        margin: 30px 0;
        padding: 20px;
        //background-color: #f9f9f9;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.8;
        color: #666;

        font-weight: 350;
        font-size: 20.12px;
        leading-trim: NONE;
        line-height: 33.96px;
        letter-spacing: -0.6px;
        vertical-align: middle;

        p {
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          &:first-child {
            font-weight: 600;
            color: #333;
          }
        }
      }

      .submit-button {
        width: 100%;
        padding: 20px;
        font-size: 18px;
        font-weight: 600;
        color: white;
        background-color: $color-blue;
        border: none;
        //border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s;
        margin-top: 40px;

        &:hover {
          background-color: darken($color-blue, 10%);
        }

        &:active {
          background-color: darken($color-blue, 15%);
        }
      }
    }
  }


  @media (max-width: 768px) {
    .consultation-content {
      padding: 50px 20px 60px;
      .section-header {
        margin-bottom: 40px;
        .section-title {
          font-size: 24px;
        }
      }
      .consultation-form {
        .form-group {
          grid-template-columns: 1fr 275px;
          .form-label {
            font-size: 16px;
            margin-bottom: 12px;
          }
          .radio-group {
            .radio-item {
              label {
                font-size: 16px;
              }
            }
          }

          .form-input,
          .form-select {
            padding: 14px 16px;
            font-size: 16px;
          }
        }

        .consent-notice {
          padding: 16px;
          font-size: 13px;
        }

        .submit-button {
          padding: 16px;
          font-size: 16px;
          margin-top: 30px;
        }
      }
    }
  }

  @media (max-width: 450px) {
    .consultation-content {
      .consultation-form {
        .form-group {
          grid-template-columns: 1fr 224px;
        }
      }
    }
  }
}


</style>
